import { render, staticRenderFns } from "./wechatzhanghu.vue?vue&type=template&id=dd34c8f6&scoped=true"
import script from "./wechatzhanghu.vue?vue&type=script&lang=js"
export * from "./wechatzhanghu.vue?vue&type=script&lang=js"
import style0 from "./wechatzhanghu.vue?vue&type=style&index=0&id=dd34c8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd34c8f6",
  null
  
)

export default component.exports